/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_ForbiddenInputs */

const fr_api_forbidden = /** @type {(inputs: Api_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre accès ne permet pas cette action. Contactez un administrateur.`)
};

const en_api_forbidden = /** @type {(inputs: Api_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your access does not allow this action. Contact an administrator.`)
};

/**
* | output |
* | --- |
* | "Your access does not allow this action. Contact an administrator." |
*
* @param {Api_ForbiddenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_forbidden = /** @type {((inputs?: Api_ForbiddenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_ForbiddenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_forbidden(inputs)
	return fr_api_forbidden(inputs)
});